/**
 * @graphql cc
 */
import gql from 'graphql-tag';
import { useQuery } from '@apollo/react-hooks';

import { getMonitoringClient } from '@confluence/monitoring';
import { Attribution, isUnauthorizedError } from '@confluence/error-boundary';
import { markErrorAsHandled } from '@confluence/graphql';

import type { useIsSiteAdminUseIsSiteAdminQuery as useIsSiteAdminUseIsSiteAdminQuery$data } from './__types__/useIsSiteAdminUseIsSiteAdminQuery';
import { getIsSiteAdminFromQuery } from './getIsSiteAdminFromQuery';

export const useIsSiteAdmin = () => {
	const {
		data,
		error,
		loading: isAdminCheckLoading,
	} = useQuery<useIsSiteAdminUseIsSiteAdminQuery$data>(gql`
		query useIsSiteAdminUseIsSiteAdminQuery {
			isSiteAdmin
		}
	`);

	if (error) {
		if (!isUnauthorizedError(error)) {
			getMonitoringClient().submitError(error, {
				attribution: Attribution.ADMIN_EXPERIENCE,
			});
		}
		markErrorAsHandled(error);
	}

	const isSiteAdmin = getIsSiteAdminFromQuery(data);

	return { isSiteAdmin, isAdminCheckLoading };
};
